import { RoutalPalette } from '@nx-smartmonkey/ui';

import { RouteStatus } from '../domain/route/RouteStatus';
import { StopStatus } from './Stops';

export const getRouteStatusColor = (status: RouteStatus, type?: `light` | `medium` | `dark`) => {
  switch (status) {
    case `finished`:
      return RoutalPalette.routeStatusColors.finished[type ?? `medium`];
    case `in_transit`:
      return RoutalPalette.routeStatusColors.in_transit[type ?? `medium`];
    default:
      return RoutalPalette.routeStatusColors.pending[type ?? `medium`];
  }
};

export const getStopStatusColor = (status?: StopStatus, type?: `light` | `medium` | `dark`) => {
  if (!status) return RoutalPalette.secondary40;

  switch (status) {
    case `completed`:
      return RoutalPalette.stopStatusColors.completed[type ?? `medium`];
    case `incomplete`:
      return RoutalPalette.stopStatusColors.incomplete[type ?? `medium`];
    case `canceled`:
      return RoutalPalette.stopStatusColors.canceled[type ?? `medium`];
    default:
      return RoutalPalette.stopStatusColors.pending[type ?? `medium`];
  }
};

export const getMarkerStatusColor = (status?: StopStatus, type?: `light` | `medium` | `dark`) => {
  if (!status) return RoutalPalette.secondary40;

  switch (status) {
    case `completed`:
      return RoutalPalette.markerStopColors.completed[type ?? `medium`];
    case `incomplete`:
      return RoutalPalette.markerStopColors.incomplete[type ?? `medium`];
    case `canceled`:
      return RoutalPalette.markerStopColors.canceled[type ?? `medium`];
    default:
      return RoutalPalette.stopStatusColors.pending[type ?? `medium`];
  }
};
